<div class="container-fluid py-3">
  <div class="row">

      <div class="col-12">

          <p-table #dt
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [filterDelay]="0"
              [loading]="parcelServiceService.loading"
              [paginator]="true"
              [rows]="10"
              [rowHover]="true"
              [rowsPerPageOptions]="[10,25,50]"
              [showCurrentPageReport]="true" 
              [value]="parcelServiceService.parcelServices"
              pDroppable="row">
              <ng-template pTemplate="caption">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-4 d-flex align-items-center">
                      Paqueterías
                    </div>

                    <div class="col-8 text-end">
                      <button
                        (click)="open()"
                        class="btn btn-success rounded-circle me-2">
                        <i class="material-icons mt-1">add</i>
                      </button>

                      <button
                        (click)="parcelServiceService.getAll()"
                        class="btn btn-primary rounded-circle me-2">
                        <i class="material-icons mt-1">refresh</i>
                      </button>

                      <button
                        class="btn btn-light rounded-circle me-2">
                        <i class="material-icons mt-1">filter_alt_off</i>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                  <tr>

                    <th></th>

                    <th pSortableColumn="parcelServiceId">
                      ID
                      <p-sortIcon field="parcelServiceId"></p-sortIcon>
                      <p-columnFilter type="text" field="parcelServiceId" display="menu"></p-columnFilter>
                    </th>

                    <th pSortableColumn="parcelService">
                      Nombre
                      <p-sortIcon field="parcelService"></p-sortIcon>
                      <p-columnFilter type="text" field="parcelService" display="menu"></p-columnFilter>
                    </th>

                    <th pSortableColumn="showExtraField">
                      Campo extra
                      <p-sortIcon field="showExtraField"></p-sortIcon>
                    </th>

                    <th pSortableColumn="status">
                      Estatus
                      <p-sortIcon field="status"></p-sortIcon>
                    </th>

                    <th></th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-parcelService let-rowIndex="rowIndex">
                  <tr class="p-selectable-row">

                    <td>
                      @if(parcelService.image) {
                        <div 
                          class="bg-center"
                          style="width: 5vh; height: 5vh;"
                          [ngStyle]="{
                            'background-image': 'url(' + parcelService.image.urlFile + ')'
                          }">
                        </div>
                      }
                    </td>

                    <td>
                      <span class="p-column-title">ID</span>
                      {{parcelService.parcelServiceId}}
                    </td>

                    <td>
                      <span class="p-column-title">Nombre</span>
                      {{parcelService.parcelService}}
                    </td>

                    <td>
                      <span class="p-column-title">Campo extra</span>
                      <p-inputSwitch
                        (onChange)="update(parcelService)"
                        [(ngModel)]="parcelService.showExtraField">
                      </p-inputSwitch>
                    </td>

                    <td>
                      <span class="p-column-title">Estatus</span>
                      <p-inputSwitch
                        (onChange)="update(parcelService)"
                        [(ngModel)]="parcelService.status">
                      </p-inputSwitch>
                    </td>

                    <td>

                      <button
                        (click)="open(parcelService)"
                        class="btn btn-sm btn-light rounded-circle me-2 my-1">
                        <i class="material-icons mt-1">edit</i>
                      </button>

                      <button
                        class="btn btn-sm btn-danger rounded-circle me-2 my-1">
                        <i class="material-icons mt-1">delete</i>
                      </button>
                    </td>
                  </tr>
              </ng-template>
          </p-table>

      </div>

  </div>
</div>